<template>
    <div class="one-to-one__section">

        <h2>{{ $t("fulfillment") }}</h2>

        <div
            id="fluid-bubbles-wrapper"
            class="grid grid--bubble-graph">
            <div class="grid__item desktop--6">
                <h3>{{ $t("correspondence-of-his-attraction") }}</h3>
                <BubbleFluidGraph
                    :key="partnerFullfillmentKey"
                    :data="partnerTraits" />
            </div>
            <div class="grid__item desktop--6">
                <h3>{{ $t("correspondence-of-your-attraction") }}</h3>
                <BubbleFluidGraph
                    :key="userFullfillmentKey"
                    :data="userTraits" />
            </div>
        </div>


    </div>
</template>

<script>

import Vue from "vue";

import BubbleFluidGraph from "@/components/bubble-graph/BubbleFluidGraph.vue";

export default {
    name: "FullfillmentSection",
    components: {
        "BubbleFluidGraph": BubbleFluidGraph
    },
    props: {
        fullfillmentData: {
            type: Array,
            required: true
        },
        userId: {
            type: String,
            required: true
        },
        partnerId: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            partnerFullfillmentKey: 0,
            userFullfillmentKey: 0,
        };
    },
    computed: {
        partnerTraits() {

            const traits = this.fullfillmentData.filter((item) => {
                if (item.report_name === "bulle_search") {
                    return item.id_person === this.partnerId;
                }
            });

            const fillData = this.fullfillmentData.filter((item) => {
                if (item.report_name === "fill") {
                    return item.id_person === this.partnerId && item.same_id_person === this.userId;
                }
            });

            const filledTraits = traits.map((item) => {
                let trait = item;

                const traitIndex = this.getObjetIndexByKey(fillData, "quality", item.quality);

                if (traitIndex > -1) {
                    trait.fill = fillData[traitIndex].fill;
                } else {
                    trait.fill = 5;
                }

                return trait;
            });

            return filledTraits;
        },
        userTraits() {
            const traits = this.fullfillmentData.filter((item) => {
                if (item.report_name === "bulle_search") {
                    return item.id_person === this.userId;
                }
            });

            const fillData = this.fullfillmentData.filter((item) => {
                if (item.report_name === "fill") {
                    return item.id_person === this.userId && item.same_id_person === this.partnerId;
                }
            });

            const filledTraits = traits.map((item) => {
                let trait = item;

                const traitIndex = this.getObjetIndexByKey(fillData, "quality", item.quality);

                if (traitIndex > -1) {
                    trait.fill = fillData[traitIndex].fill;
                } else {
                    trait.fill = 5;
                }

                return trait;
            });

            return filledTraits;
        },
    },
    watch: {
        partnerTraits(val, oldVal) {
            // To force reload of the partnerFullfillment graph, use the :key increment trick
            // https://michaelnthiessen.com/force-re-render/
            this.partnerFullfillmentKey += 1;
        },
        userTraits(val, oldVal) {
            // To force reload of the userFullfillment graph, use the :key increment trick
            // https://michaelnthiessen.com/force-re-render/
            this.userFullfillmentKey += 1;
        }
    },
    mounted: function() {
    },
    methods: {
        getBubbleSize(value) {

            const baseWidth = 1000;

            return (baseWidth / 100) * value;
        }
    }
};

</script>